import moment from 'moment';

export default function quickDateFormat(date) {
    return moment.utc(date).format('DD/MM/YYYY - HH:mm');
}